module.exports = __webpack_public_path__ + "static/plain-bold-c88a4409dff8b6ba28c16a5fe352c2db.woff";